/* eslint-disable no-param-reassign */
import TWIAJobHelper from 'ent-capability-quoteandbind-common-react/util/TWIAJobHelper';
import _ from 'lodash';

const getConstructionType = (submissionVM) =>
    TWIAJobHelper.isPolicyChange(submissionVM.value)
        // eslint-disable-next-line no-secrets/no-secrets
        ? _.get(submissionVM, 'lobData.homeowners_tfpa.coverables_Ext.construction.constructionType.value.code')
        : _.get(submissionVM, 'lobData.homeowners_tfpa.coverables.construction.constructionType.value.code');

const getYourHome = (submissionVM) => TWIAJobHelper.isPolicyChange(submissionVM.value)
    ? submissionVM.lobData.homeowners_tfpa.coverables_Ext.yourHome.value
    : submissionVM.lobData.homeowners_tfpa.coverables.yourHome.value

const valuationRefresh = (submissionVM) => TWIAJobHelper.isPolicyChange(submissionVM.value)
    ? submissionVM.lobData.homeowners_tfpa.coverables_Ext.yourHome.valuationRefreshAvailable_Ext.value
    : submissionVM.lobData.homeowners_tfpa.coverables.yourHome.valuationRefreshAvailable_Ext.value

const msbValue = (submissionVM) => TWIAJobHelper.isPolicyChange(submissionVM.value)
    ? submissionVM.lobData.homeowners_tfpa.coverables_Ext.yourHome.msbValue_Ext.value
    : submissionVM.lobData.homeowners_tfpa.coverables.yourHome.msbValue_Ext.value

const actualCashValue = (submissionVM) => TWIAJobHelper.isPolicyChange(submissionVM.value)
    ? submissionVM.lobData.homeowners_tfpa.coverables_Ext.yourHome.actualCashValue_Ext.value
    : submissionVM.lobData.homeowners_tfpa.coverables.yourHome.actualCashValue_Ext.value

const policyType = (submissionVM) => TWIAJobHelper.isPolicyChange(submissionVM.value)
    ? submissionVM.lobData.homeowners_tfpa.coverables_Ext.yourHome.policyType_Ext.value.code
    : submissionVM.lobData.homeowners_tfpa.coverables.yourHome.policyType_Ext.value.code

const dwellingUsage = (submissionVM) => TWIAJobHelper.isPolicyChange(submissionVM.value)
    ? submissionVM.lobData.homeowners_tfpa.coverables_Ext.yourHome.dwellingUsage.value
    : submissionVM.lobData.homeowners_tfpa.coverables.yourHome.dwellingUsage.value

const occupancy = (submissionVM) => TWIAJobHelper.isPolicyChange(submissionVM.value)
    ? submissionVM.lobData.homeowners_tfpa.coverables_Ext.yourHome.occupancy.value
    : submissionVM.lobData.homeowners_tfpa.coverables.yourHome.occupancy.value

const valuationCompleted = (submissionVM) => TWIAJobHelper.isPolicyChange(submissionVM.value)
    ? submissionVM.lobData.homeowners_tfpa.coverables_Ext.yourHome.valuationCompleted_Ext.value
    : submissionVM.lobData.homeowners_tfpa.coverables.yourHome.valuationCompleted_Ext.value

const setMSBValue = (submissionVM, value) => {
    if (TWIAJobHelper.isPolicyChange(submissionVM.value)) {
        submissionVM.lobData.homeowners_tfpa.coverables_Ext.yourHome.msbValue_Ext.value = value
    } else {
        submissionVM.lobData.homeowners_tfpa.coverables.yourHome.msbValue_Ext.value = value
    }
}

const setValuationRefresh = (submissionVM, value) => {
    if (TWIAJobHelper.isPolicyChange(submissionVM.value)) {
        submissionVM.lobData.homeowners_tfpa.coverables_Ext.yourHome.valuationRefreshAvailable_Ext.value = value
    } else {
        submissionVM.lobData.homeowners_tfpa.coverables.yourHome.valuationRefreshAvailable_Ext.value = value
    }
}

const setValuationCompleted = (submissionVM, value) => {
    if (TWIAJobHelper.isPolicyChange(submissionVM.value)) {
        submissionVM.lobData.homeowners_tfpa.coverables_Ext.yourHome.valuationCompleted_Ext.value = value
    } else {
        submissionVM.lobData.homeowners_tfpa.coverables.yourHome.valuationCompleted_Ext.value = value
    }
}

const setActualCashValue = (submissionVM, value) => {
    if (TWIAJobHelper.isPolicyChange(submissionVM.value)) {
        submissionVM.lobData.homeowners_tfpa.coverables_Ext.yourHome.actualCashValue_Ext.value = value
    } else {
        submissionVM.lobData.homeowners_tfpa.coverables.yourHome.actualCashValue_Ext.value = value
    }
}

export default {
    'getConstructionType': getConstructionType,
    'getYourHome': getYourHome,
    'valuationRefresh': valuationRefresh,
    'msbValue': msbValue,
    'actualCashValue': actualCashValue,
    'policyType': policyType,
    'dwellingUsage': dwellingUsage,
    'occupancy': occupancy,
    'valuationCompleted': valuationCompleted,
    'setMSBValue': setMSBValue,
    'setValuationRefresh': setValuationRefresh,
    'setValuationCompleted': setValuationCompleted,
    'setActualCashValue': setActualCashValue
};
